const convertToQueryString = (paramObject, encodeUri) => {
    return Object.keys(paramObject)
        .map(
            key =>
                key +
                "=" +
                (encodeUri
                    ? encodeURIComponent(paramObject[key])
                    : paramObject[key])
        )
        .join("&");
};

export default convertToQueryString;
